import {
  GET_SYSTEM_DEVICE_LIST,
  GET_SYSTEM_DEVICE_LIST_SUCCESS,
  GET_SYSTEM_DEVICE_LIST_FAILURE,
  GET_EPOSSYSTEM_DATA,
  GET_EPOSSYSTEM_DATA_SUCCESS,
  GET_EPOSSYSTEM_DATA_FAILURE,
  CREATE_SYSTEM_DEVICE,
  CREATE_SYSTEM_DEVICE_SUCCESS,
  CREATE_SYSTEM_DEVICE_FAILURE,
  UPDATE_SYSTEM_DEVICE,
  UPDATE_SYSTEM_DEVICE_SUCCESS,
  UPDATE_SYSTEM_DEVICE_FAILURE,
  DELETE_SYSTEM_DEVICE,
  DELETE_SYSTEM_DEVICE_SUCCESS,
  DELETE_SYSTEM_DEVICE_FAILURE,
} from "./actionType";

const initState = {
  systemDeviceList: [],
  systemDeviceListLoading: false,
  systemDeviceListError: null,

  eposSystemData: null,
  eposSystemDataLoading: false,
  eposSystemDataError: null,

  systemDeviceCreate: null,
  systemDeviceCreateLoading: false,
  systemDeviceCreateError: null,

  systemDeviceUpdate: null,
  systemDeviceUpdateLoading: false,
  systemDeviceUpdateError: null,

  systemDeviceDelete: null,
  systemDeviceDeleteLoading: false,
  systemDeviceDeleteError: null,
};

const SystemDevice = (state = initState, { type, payload }) => {
  switch (type) {
    case GET_SYSTEM_DEVICE_LIST:
      return {
        ...state,
        systemDeviceListLoading: true,
        systemDeviceListError: null,
      };
    case GET_SYSTEM_DEVICE_LIST_SUCCESS:
      return {
        ...state,
        systemDeviceList: payload,
        systemDeviceListLoading: false,
        systemDeviceListError: null,
      };
    case GET_SYSTEM_DEVICE_LIST_FAILURE:
      return {
        ...state,
        systemDeviceList: [],
        systemDeviceListLoading: false,
        systemDeviceListError: payload,
      };

    case GET_EPOSSYSTEM_DATA:
      return {
        ...state,
        eposSystemDataLoading: true,
        eposSystemDataError: null,
      };
    case GET_EPOSSYSTEM_DATA_SUCCESS:
      return {
        ...state,
        eposSystemData: payload,
        eposSystemDataLoading: false,
        eposSystemDataError: null,
      };
    case GET_EPOSSYSTEM_DATA_FAILURE:
      return {
        ...state,
        eposSystemData: null,
        eposSystemDataLoading: false,
        eposSystemDataError: payload,
      };

    case CREATE_SYSTEM_DEVICE:
      return {
        ...state,
        systemDeviceCreateLoading: true,
        systemDeviceCreateError: null,
      };
    case CREATE_SYSTEM_DEVICE_SUCCESS:
      return {
        ...state,
        systemDeviceCreate: payload,
        systemDeviceCreateLoading: false,
        systemDeviceCreateError: null,
      };
    case CREATE_SYSTEM_DEVICE_FAILURE:
      return {
        ...state,
        systemDeviceCreate: null,
        systemDeviceCreateLoading: false,
        systemDeviceCreateError: payload,
      };

    case UPDATE_SYSTEM_DEVICE:
      return {
        ...state,
        systemDeviceUpdateLoading: true,
        systemDeviceUpdateError: null,
      };
    case UPDATE_SYSTEM_DEVICE_SUCCESS:
      return {
        ...state,
        systemDeviceUpdate: payload,
        systemDeviceUpdateLoading: false,
        systemDeviceUpdateError: null,
      };
    case UPDATE_SYSTEM_DEVICE_FAILURE:
      return {
        ...state,
        systemDeviceUpdate: null,
        systemDeviceUpdateLoading: false,
        systemDeviceUpdateError: payload,
      };

    case DELETE_SYSTEM_DEVICE:
      return {
        ...state,
        systemDeviceDeleteLoading: true,
        systemDeviceDeleteError: null,
      };
    case DELETE_SYSTEM_DEVICE_SUCCESS:
      return {
        ...state,
        systemDeviceDelete: payload,
        systemDeviceDeleteLoading: false,
        systemDeviceDeleteError: null,
      };
    case DELETE_SYSTEM_DEVICE_FAILURE:
      return {
        ...state,
        systemDeviceDelete: null,
        systemDeviceDeleteLoading: false,
        systemDeviceDeleteError: payload,
      };

    default:
      return state;
  }
};

export default SystemDevice;
